export default __webpack_public_path__ + "static/media/jobllegro-320.66b981e1.png";